<template lang="pug">
	section#gradeCurricular
		div.wrapper
			div.conteudo
				h2
					|Olha só o que
					br
					|você vai aprender.
				p
					|O curso 
					strong “Educação a Distância 4.0” 
					|proporciona ao educador o conhecimento sobre os novos meios e formas de educar, tendo os recursos tecnológicos 
					|como seus maiores aliados. Nele aprenderá a relação entre educação e tecnologia, as alternativas e sistemas 
					|multimídias disponíveis para o ensino, metodologias ativas e novas metodologias de ensino. 
					strong São 560 horas de conteúdo gratuito! 
					|Ao final, o aluno, se desejar o título de pós-graduação, poderá contratar e se matricular no módulo de TCC, com mais 60 horas, e 
					strong receber a Certificação de Especialista como Pós-Graduado 
					|neste tema. 
					br
					|A grade curricular gratuita inclui as seguintes disciplinas: 
				ul
					li
						|• Introdução à EaD - 80 horas;
					li
						|• Educação e Tecnologia – 80 horas;
					li    
						|• Sistemas Multimídia – 80 horas;
					li    
						|• Metodologias Ativas – 80 horas;
					li    
						|• Educação a Distância e Novas Modalidades de Ensino – 80 horas;
					li     
						|• Sociologia e Ética Profissional – 80 horas;
					li     
						|• Pensamento Científico – 80 horas.
				a(href="https://media.fael.edu.br/regulamentos/regulamento-pos-conteudo-gratuito-fael", target="_blank").confiraRegulamento Confira o regulamento completo
</template>

<script>
export default {
	name: "section-grade-curricular"
}
</script>

<style lang="stylus" scoped src="./GradeCurricular.styl"></style>